import { useUserState } from '../state';

const useResetAllState = () => {
  const { resetFilterState } = useUserState();

  const onResetAllState = () => {
    resetFilterState();
  };

  return onResetAllState;
};

export default useResetAllState;
